import { GetQuery } from "./getQuery";
import { defaultReferral } from "../../env-exports";

const REFERRAL_STORAGE_KEY = 'oauth_referral_url';

/**
 * Get referral URL from query params or return default
 */
export const getReferralFromQuery = (): string => {
  return GetQuery().get("referral") ?? defaultReferral;
};

/**
 * Save referral URL to sessionStorage before OAuth redirect
 */
export const saveReferralUrl = (url: string): void => {
  sessionStorage.setItem(REFERRAL_STORAGE_KEY, url);
};

/**
 * Retrieve and clear referral URL from sessionStorage after OAuth callback
 */
export const getAndClearReferralUrl = (): string | null => {
  const url = sessionStorage.getItem(REFERRAL_STORAGE_KEY);
  if (url) {
    sessionStorage.removeItem(REFERRAL_STORAGE_KEY);
  }
  return url;
};
